import { Suspense, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useSearchParams,
    useNavigate,
    useLoaderData,
    json
} from 'react-router-dom'
import { book } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Book.module.scss'

import { useEffect } from 'react'

export const loader = async () => {
    return defer({ book: book() })
}

export default function Book() {
    const pageName = 'کتابخانه مجازی'
    Title(pageName)
    const [loaderData, setLoaderData] = useState(useLoaderData())
    const [error, setError] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState()
    const [showPopup, setShowPopup] = useState(false)
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()

    useEffect(() => {
        document.querySelector('header span').innerText = pageName
    }, [])

    return (
        <section className={styles.section}>
            <div className='__frame' data-width={`large`}>
            <Link to={`../`} className='button' style={{ maxWidth: '100px', margin: '1rem auto' }}>بازگشت</Link>
                <div className='grid grid--fit grid--gap-1' style={{ '--data-width': '250px', 'width': '100%' }}>
                    <Suspense fallback={<LoadingSpinner />}>
                        <Await
                            resolve={loaderData.book}
                            errorElement={<p>⚠️</p>}>
                            {(data) => {
                                console.log(data)
                                return (
                                    <>
                                        {
                                            data.map((item) => {
                                                return <div className={styles.item}>
                                                    <div className={`${styles.itemBody} d-flex flex-column align-items-center justify-content-between`} style={{ columnGap: '1rem' }}>
                                                        <figure className={styles.gallery}>
                                                            <img src={`${process.env.REACT_APP_UPLOAD}images/${item.image}`} />
                                                        </figure>

                                                        <ul>
                                                            <li>
                                                                <label>نام کتاب:</label>
                                                                {item.name}
                                                            </li>
                                                            <li>
                                                                <label>نویسنده:</label>
                                                                {item.author}
                                                            </li>
                                                            <li>
                                                                <label>مترجم:</label>
                                                                {item.translator}
                                                            </li>
                                                            <li>
                                                                <label>تعداد صفحات کتاب:</label>
                                                                {item.pages} صفحه
                                                            </li>
                                                            <li>
                                                                {
                                                                    item.file && <>
                                                                        <label>مشاهده فایل:</label>
                                                                        <a className='ms-depth-4' href={`${process.env.REACT_APP_UPLOAD}doc/${item.file}`} target='_blank'>
                                                                            مشاهده
                                                                        </a>
                                                                    </>
                                                                }
                                                            </li>
                                                            <li>
                                                                <label>توضیحات:</label>
                                                                {item.description}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </>
                                )

                            }}
                        </Await>
                    </Suspense>
                </div>
                
            </div>
            <Link to={`../`} className='button' style={{ maxWidth: '100px', margin: '1rem auto', position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)' }}>بازگشت</Link>
            
        </section>
    )
}